import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon } from 'semantic-ui-react';
import { useAuth } from '../../context/AuthContext';

interface AbrirProtocoloPosVendaLinkProps {
  clientId?: string | null;
  size?: 'mini' | 'small' | 'medium';
  basic?: boolean;
}

/** RF21 — atalho para `/pos-venda` com cliente pré-selecionado. */
export const AbrirProtocoloPosVendaLink: React.FC<AbrirProtocoloPosVendaLinkProps> = ({
  clientId,
  size = 'small',
  basic = true,
}) => {
  const { hasRole } = useAuth();
  if (!clientId || !hasRole('Admin')) return null;
  const to = `/pos-venda?clientId=${encodeURIComponent(clientId)}`;
  return (
    <Button as={Link} to={to} size={size} basic={basic} color="teal">
      <Icon name="plus square outline" />
      Abrir protocolo de pós-venda
    </Button>
  );
};

export default AbrirProtocoloPosVendaLink;
